import { Skeleton, Stack } from '@mantine/core';

export default function LoadingPromo() {
  return (
    <Stack p="lg">
      <Skeleton h={248} />
      <Skeleton w="20%" mt={14} />
      <Skeleton h={12} />
      <Skeleton h={12} />
      <Skeleton w="80%" h={12} />
      <Skeleton w="40%" mt={14} h={12} />
      <Skeleton h={12} />
      <Skeleton h={12} />
      <Skeleton w="80%" h={12} />
    </Stack>
  );
}
